import MultiSelect from 'corp/components/UI/Select';
import { CalculationType } from '@scale/genai-compass-shared/cards/percentage';
import { ColumnType, Column } from '@scale/compass-shared/types';
import usePercentageCard from './usePercentageCard';
import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';

const PercentageCardComponent: CompassCardComponent = ({ index }: CompassCardComponentProps) => {
  const {
    calculationType,
    setCalculationType,
    allColumns,
    selectedColumnIds,
    setSelectedColumnIds,
  } = usePercentageCard(index);

  return (
    <div>
      <hr className="border-neutral-200 mb-1" />
      <div className="p-4">
        <div>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-4">
              <div className="my-3 font-semibold">Calculation Type</div>
              <MultiSelect
                className="w-full rounded-lg"
                label="Select Calculation"
                multi={false}
                options={Object.values(CalculationType).map(type => ({
                  label: type.replace(/_/g, ' ').toUpperCase(),
                  value: type,
                }))}
                disabled={false}
                placeholder="Select calculation type..."
                isSearchable={true}
                isClearable={true}
                value={
                  calculationType
                    ? {
                        label: calculationType.replace(/_/g, ' ').toUpperCase(),
                        value: calculationType,
                      }
                    : null
                }
                onChange={({ value }: { value: CalculationType | null }) => {
                  if (value) {
                    setCalculationType(value);
                  }
                }}
              />
            </div>

            <div className="col-span-8">
              <div className="my-3 font-semibold">Columns to Convert</div>
              <MultiSelect
                className="w-full rounded-lg"
                label="Select Columns"
                multi={true}
                options={(allColumns ?? [])
                  .filter((col: Column) => col.type === ColumnType.NUMBER)
                  .map((column: Column) => ({
                    label: column.id,
                    value: column.id,
                  }))}
                disabled={false}
                placeholder="Select columns..."
                isSearchable={true}
                isClearable={true}
                value={selectedColumnIds}
                onChange={(e: { _label: string; value: string }[]) => {
                  setSelectedColumnIds(e.map(({ value }) => value));
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PercentageCardComponent;
